import React from "react";
import ctl from "@netlify/classnames-template-literals";
import { MenuItems } from "./menu-items";
import MenuIcon from "assets/images/svgs/menu.svg";
import CloseIcon from "assets/images/svgs/x.svg";
import { Button } from "components/button";

const Menu = ({ openMenu, onToggle, theme }) => {
  const menuIconAriaLabel = openMenu ? "menu icon" : "close menu icon";

  return (
    <div className="lg:w-full">
      {/* hamburger menu for mobile */}
      <button
        onClick={onToggle}
        className="lg:hidden"
        aria-label={menuIconAriaLabel}
      >
        {openMenu ? (
          <CloseIcon className={iconStyle[theme]} />
        ) : (
          <MenuIcon className={iconStyle[theme]} />
        )}
      </button>

      <nav className={`${navWrapStyle} ${openMenu ? "block" : "hidden"}`}>
        <MenuItems />

        <div className="mt-10 lg:mt-0 max-w-[239px] ml-4">
          <Button text="Get in touch" to="/get-demo" size="xsmall" />
        </div>
      </nav>
    </div>
  );
};

const navWrapStyle = ctl(`
  lg:flex 
  items-center
  justify-end
  absolute
  lg:static
  left-0
  top-[72px]
  w-full
  z-10
  lg:h-auto
  h-[95vh]
  lg:bg-transparent
  bg-secondary-100
  lg:overflow-hidden
  overflow-scroll
`);

const iconStyle = {
  dark: `stroke-secondary-100`,
  light: `stroke-secondary`,
};

export { Menu };
